import React from 'react'
import moment from 'moment-timezone'
import {
  Popup
} from 'camino-react'
import _ from 'lodash'

import StringManipulator from 'Utilities/StringManipulator'

export default class TicketCorrespondenceLogItem extends React.Component {
  constructor (props) {
    super(props)
    this.commentTypeClasses = {
      correspondence: 'lnr-inbox2',
      call: 'lnr-telephone',
      internal_note: 'lnr-document'
    }
    this.commentTypeVerbose = {
      correspondence: 'Email',
      call: 'Call Log',
      internal_note: 'Internal Note'
    }
  }

  contentClassNames () {
    const classNames = ['correspondence__content']
    const { comment } = this.props

    if (!comment.client) {
      classNames.push('correspondence__content--support')
    }

    if (comment.communication_type === 'internal_note') {
      classNames.push('correspondence__content--internal')
    }

    return classNames.join(' ')
  }

  emailSrcUrl() {
    const { comment } = this.props
    const urlParams = new URLSearchParams(window.location.search);
    const userToken = urlParams.get('user_token')

    if (userToken) {
      return `/emails/${comment.commentable_id}?user_token=${userToken}`
    }

    return `/emails/${comment.commentable_id}`
  }

  render () {
    const { comment } = this.props

    const listStyles = {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      listStyle: 'none'
    }

    return (
      <div className="correspondence">
        <div className="correspondence__header correspondence__header--space-between">
          <p className="correspondence__header--text">
            <span
              className={`lnr ${
                this.commentTypeClasses[comment.communication_type]
              } correspondence__header--icon`}
              data-toggle="tooltip"
              title={this.commentTypeVerbose[comment.communication_type]}
            />
            {`${comment.user_name} ${moment(comment.created_at).format(
              'DD MMMM YYYY, hh:mmA'
            )}`}
          </p>
          {comment.commentable_type === 'Email' && (
            <Popup
              modal
              trigger={() => (
                <button
                  type="button"
                  className="button button--outline button--compact"
                >
                  Show Origin
                </button>
              )}
            >
              <iframe
                src={this.emailSrcUrl()}
                title={`${comment.commentable_id}`}
                width="100%"
                height="600"
                style={{ border: 'none' }}
              />
            </Popup>
          )}
        </div>
        <div className={this.contentClassNames()}>
          <div className="correspondence__content--text">
            {StringManipulator.simpleFormat(comment.content)}
            {_.isEmpty(comment.attachments) ? null : (
              <div>
                <hr />
                <small>
                  Attachments:
                  {_.map(comment.attachments, attachment => (
                    <li style={listStyles}>
                      <a
                        href={attachment.url}
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        {attachment.filename}
                      </a>
                    </li>
                  ))}
                </small>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}
